export const APPROVAL_PACKAGE_STATUS = {
    APPROVED_PRE_PRIORITY: 'APPROVED_PRE_PRIORITY',
};

export const fieldsToDisplay = [
    { key: 'supName', label: 'שם ספק' },
    { key: 'supNumber', label: 'מספר ספק' },
    { key: 'status', label: 'סטטוס' },
    { key: 'goodsReceipt', label: 'קבלת סחורה' },
    { key: 'createdAt', label: 'תאריך קבלת סחורה' }
];

export const fieldsToSearch = [
    { key: 'supName', name: 'שם ספק' },
    { key: 'supNumber', name: 'מספר ספק' },
    { key: 'goodsReceipt', name: 'קבלת סחורה' },
    { key: 'fromDate', name: 'מתאריך' },
    { key: 'toDate', name: 'עד תאריך' }
];

export const formatValue = (value) => {
    if (value === null || value === undefined) return "-";
    if (typeof value === "object") {
        if (value instanceof Date) {
            return value.toLocaleDateString();
        }
        if (Array.isArray(value)) {
            return value.join(", ");
        }
        return Object.entries(value)
            .map(([key, val]) => `${key}: ${val}`)
            .join(", ");
    }
    return value.toString();
};